import { LongTermStock } from '../_types/longterm.type'

export function computeBuyZone(stock: LongTermStock): { stopLoss: number; buyUpTo: number } {
  return {
    stopLoss: stock.entryPX * 0.75,
    buyUpTo: stock.entryPX * 1.25
  }
}

export function isInBuyZone(stock: LongTermStock): boolean {
  if (stock.isSold) return false
  if (stock.skipUpdate) return false
  if (stock.currentPX == null) return false
  const { stopLoss, buyUpTo } = computeBuyZone(stock)
  return stock.currentPX > stopLoss && stock.currentPX < buyUpTo
}

export function filterInBuyZone(stocks: LongTermStock[]): LongTermStock[] {
  return stocks.filter(isInBuyZone)
}

export function countActive(stocks: LongTermStock[]): number {
  return stocks.filter(s => !s.isSold && !s.skipUpdate).length
}

export function gainPct(entry: number | undefined, final: number | undefined): number | null {
  if (entry == null || final == null) return null
  if (entry === 0) return null
  return ((final - entry) / entry) * 100
}

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000

export function filterRecentBuys(stocks: LongTermStock[], now: Date = new Date()): LongTermStock[] {
  const dayStart = new Date(now)
  dayStart.setUTCHours(0, 0, 0, 0)
  const cutoff = dayStart.getTime() - SEVEN_DAYS_MS
  return stocks
    .filter(s => !s.isSold)
    .map(s => ({ s, t: new Date(s.entryDate).getTime() }))
    .filter(({ t }) => Number.isFinite(t) && t >= cutoff)
    .sort((a, b) => b.t - a.t)
    .map(({ s }) => s)
}

export function filterRecentSells(stocks: LongTermStock[], now: Date = new Date()): LongTermStock[] {
  const dayStart = new Date(now)
  dayStart.setUTCHours(0, 0, 0, 0)
  const cutoff = dayStart.getTime() - SEVEN_DAYS_MS
  return stocks
    .filter(s => s.isSold === true && s.soldDate != null)
    .map(s => ({ s, t: new Date(s.soldDate as string).getTime() }))
    .filter(({ t }) => Number.isFinite(t) && t >= cutoff)
    .sort((a, b) => b.t - a.t)
    .map(({ s }) => s)
}
